/* 635 v1: revalidate existing cart prices without changing quantities, discounts or attributes. */
(function (host) {
  function createCart(deps) {
    var busy = false;
    async function request(kind, item) {
      var root = deps.root();
      if (!root || busy || kind === 'refresh' && !root.querySelector('.ocp-cart__line')) return;
      busy = true;
      var controls = Array.from(root.querySelectorAll('button,input'));
      controls.forEach(function (el) { el.disabled = true; });
      root.setAttribute('aria-busy', 'true');
      var error = root.querySelector('[data-cart-error]');
      if (error) error.hidden = true;
      try {
        var refresh = kind === 'refresh';
        var body = refresh ? { updates: {}, sections: [root.dataset.sectionId], sections_url: deps.pathname() } : item;
        var response = await deps.fetch(refresh ? root.dataset.updateUrl : root.dataset.changeUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          signal: deps.signal(), body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error('cart_update_failed');
        var cart = await response.json();
        if (!cart || !Array.isArray(cart.items)) throw new Error('cart_response_invalid');
        if (refresh) {
          var html = cart.sections && cart.sections[root.dataset.sectionId];
          if (typeof html !== 'string' || !deps.render(root, html)) throw new Error('cart_section_invalid');
        } else deps.reload();
        return { status: response.status };
      } catch (_) {
        if (error) { error.textContent = root.dataset.error; error.hidden = false; }
      } finally {
        controls.forEach(function (el) { el.disabled = false; });
        root.removeAttribute('aria-busy'); busy = false;
      }
    }
    return { refresh: function () { return request('refresh'); }, change: function (key, qty) {
      return request('change', { id: key, quantity: Math.max(0, parseInt(qty, 10) || 0) });
    }, busy: function () { return busy; } };
  }
  if (typeof module === 'object' && module.exports) { module.exports = { createCart: createCart }; return; }
  var cart = createCart({
    root: function () { return document.querySelector('[data-ocp-cart]'); },
    pathname: function () { return location.pathname; },
    fetch: function (url, options) { return fetch(url, options); },
    signal: function () { return AbortSignal.timeout(8000); },
    reload: function () { location.reload(); },
    render: function (root, html) {
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ocp-cart]');
      if (!next || next.dataset.sectionId !== root.dataset.sectionId) return false;
      root.replaceWith(next); return true;
    }
  });
  host.ocpCart = cart.change;
  document.addEventListener('click', function (event) {
    if (cart.busy() && event.target.closest('.ocp-cart__checkout')) event.preventDefault();
  });
  host.addEventListener('pageshow', function (event) { if (event.persisted) void cart.refresh(); });
  void cart.refresh();

  /* 910 v2: export DAP consent (checkbox locked while saving) — the checkbox writes a cart attribute that reaches the order; checkout waits for it. */
  function customsError(wrap, text) {
    var err = wrap.querySelector('[data-ocp-customs-err]');
    if (!err) return;
    err.textContent = text || '';
    err.hidden = !text;
  }
  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('[data-ocp-customs-accept]');
    var wrap = box && box.closest('[data-ocp-customs]');
    var root = document.querySelector('[data-ocp-cart]');
    if (!wrap || !root) return;
    var attributes = { 'Import duties (DAP)': box.checked ? 'Accepted ' + new Date().toISOString() + ' · ' + wrap.dataset.country : '' };
    box.disabled = true;
    wrap.setAttribute('aria-busy', 'true');
    customsError(wrap, '');
    fetch(root.dataset.updateUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      signal: AbortSignal.timeout(8000), body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('customs_attribute_failed');
    }).catch(function () {
      box.checked = !box.checked;
      customsError(wrap, wrap.dataset.saveError);
    }).finally(function () { box.disabled = false; wrap.removeAttribute('aria-busy'); });
  });
  document.addEventListener('click', function (event) {
    var wrap = event.target.closest('.ocp-cart__checkout') && document.querySelector('[data-ocp-customs]');
    var box = wrap && wrap.querySelector('[data-ocp-customs-accept]');
    if (!box || box.checked && !wrap.hasAttribute('aria-busy')) return;
    event.preventDefault();
    if (box.checked) return;
    customsError(wrap, wrap.dataset.required);
    box.focus();
  });
})(typeof window === 'object' ? window : globalThis);
